const CurrentStepIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#FFE458" />
    <path
      d="M10.875 8.28125L8.125 10.9062C7.96875 11.0469 7.73438 11.0469 7.59375 10.8906C7.45312 10.7344 7.45312 10.5 7.60938 10.3594L9.6875 8.375H4.375C4.15625 8.375 4 8.21875 4 8C4 7.79688 4.15625 7.625 4.375 7.625H9.6875L7.60938 5.65625C7.45312 5.51562 7.45312 5.26562 7.59375 5.125C7.73438 4.96875 7.98438 4.96875 8.125 5.10938L10.875 7.73438C10.9531 7.8125 11 7.90625 11 8C11 8.10938 10.9531 8.20312 10.875 8.28125Z"
      fill="#292747"
    />
  </svg>
);
export default CurrentStepIcon;
